import React from 'react'
import { Link } from 'react-router-dom'

export const testimonials = [
  (
    <div>
      <blockquote className="blockquote">"I love homeboy’s voice and enthusiasm for the stuff. Like a great convo over drinks with a great storyteller."</blockquote>
      <p><em>- Bender B Bender</em> listening to <Link to="/products">Absurd History</Link></p>
    </div>
  ), (
    <div>
      <blockquote className="blockquote">"Great jumping off point: Exactly what it needs to be- entertaining idea source for further research, they are fun and clear. Good job!"</blockquote>
      <p><em>- karmi1381</em> listening to <Link to="/products">Absurd History</Link></p>
    </div>
  ), (
    <div>
      <blockquote className="blockquote">"Exactly what it says: These gentlemen are bringing up the funniest and most absurd (duh) moments in history, very clear and never fails for a laugh. One of my favorites."</blockquote>
      <p><em>- Walker1010</em> listening to <Link to="/products">Absurd History</Link></p>
    </div>
  ), (
    <div>
      <blockquote className="blockquote">"Absolutely fantastic. I just watched 2 videos and the geospatial information is invaluable in understanding the battles."</blockquote>
      <p><em>- ScaryShoes</em> about <Link to="/products">History Mapped</Link></p>
    </div>
  ), (
    <div>
      <blockquote className="blockquote">"Awesome site! I really like how it puts the battles in context on the map! Like, when reading about different battles, I always want to know exactly where they took place, this lets you do that."</blockquote>
      <p><em>- westherm</em> about <Link to="/products">History Mapped</Link></p>
    </div>
  ), (
    <div>
      <blockquote className="blockquote">"I immediately bookmarked the page, super helpful and informative."</blockquote>
      <p><em>- JarretGax</em> about <Link to="/products">History Mapped</Link></p>
    </div>
  ), (
    <div>
      <blockquote className="blockquote">"Had not realised the Battle of Tours was so far north... Great site, bookmarked."</blockquote>
      <p><em>- MyHandsAreRed</em> about <Link to="/products">History Mapped</Link></p>
    </div>
  ), (
    <div>
      <blockquote className="blockquote">"Thank you for spending the time to walk me through everything"</blockquote>
      <p><em>- Student</em> at Ligthouse Labs</p>
    </div>
  ), (
    <div>
      <blockquote className="blockquote">"Zach was great as always"</blockquote>
      <p><em>- Student</em> at Lighthouse Labs</p>
    </div>
  ), (
    <div>
      <blockquote className="blockquote">"Zach always understood my most difficult questions, even when they threw other mentors for a loop"</blockquote>
      <p><em>- Student</em> at Lighthouse Labs</p>
    </div>
  ), (
    <div>
      <blockquote className="blockquote">"Zach was very knowledgeable and patient in guiding us"</blockquote>
      <p><em>- Student</em> at Lighthouse Labs</p>
    </div>
  ), (
    <div>
      <blockquote className="blockquote">"thank you for leaving good comments and documentation everywhere"</blockquote>
      <p><em>- Co-worker</em> at Bite</p>
    </div>
  ), (
    <div>
      <blockquote className="blockquote">"Thank you! #cultureleader"</blockquote>
      <p><em>- Co-worker</em> at Bite</p>
    </div>
  )
  // Testimonials.css needs to be updated after adding a testimonial
]



// WEBPACK FOOTER //
// ./src/Testimonials/testimonials.js